import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("button", {
    type: "button",
    class: "leading-none inline-block transition-all relative top-[2px] hover:text-primary-500",
    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggleFullscreen && _ctx.toggleFullscreen(...args)))
  }, _cache[1] || (_cache[1] = [
    _createElementVNode("i", {
      class: "material-symbols-outlined !text-[22px] md:!text-[24px]",
      id: "fullscreenIcon"
    }, " fullscreen ", -1)
  ])))
}